import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/blue-arrow-left.svg'
import _imports_1 from '@/assets/printing-assets/issue-1.svg'
import _imports_2 from '@/assets/phone.svg'
import _imports_3 from '@/assets/mail.svg'


_pushScopeId("data-v-06c4128d")
const _hoisted_1 = { class: "modal-header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Return to Troubleshooting", -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "modal-content" }
const _hoisted_6 = { id: "info" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { id: "title" }, "My printed page is too small", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" If the size of your artwork is smaller than the actual labels on your sheet you will need to configure the "),
  /*#__PURE__*/_createElementVNode("strong", null, "scale"),
  /*#__PURE__*/_createTextVNode(" in your printer settings. Set the "),
  /*#__PURE__*/_createElementVNode("strong", null, "scale"),
  /*#__PURE__*/_createTextVNode(" setting to "),
  /*#__PURE__*/_createElementVNode("strong", null, "100%"),
  /*#__PURE__*/_createTextVNode(" or "),
  /*#__PURE__*/_createElementVNode("strong", null, "Actual Size"),
  /*#__PURE__*/_createTextVNode(". Never print your labels at a Custom Scale, Fit to Page or using the Shrink Oversized Pages setting. ")
], -1)
const _hoisted_9 = {
  key: 0,
  id: "img-wrap"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { id: "contact" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Need more help? We're here!"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" Our expert customer service team is ready to help you with any questions or concerns you may have. Real time help is available "),
    /*#__PURE__*/_createElementVNode("strong", null, "Monday through Friday 9AM-6pm EST")
  ]),
  /*#__PURE__*/_createElementVNode("div", { id: "contact-info" }, [
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }),
      /*#__PURE__*/_createElementVNode("a", { href: "tel:888-388-2502" }, "888-388-2502")
    ]),
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }),
      /*#__PURE__*/_createElementVNode("a", { href: "mailto:support@sheetlabels.com" }, "support@sheetlabels.com")
    ])
  ])
], -1)
const _hoisted_13 = {
  key: 0,
  id: "img-wrap"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_15 = [
  _hoisted_14
]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseSVG = _resolveComponent("CloseSVG")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.fadeTransition, "modal"])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass([_ctx.bounceTransition, "modal-body"])
      }, [
        _createElementVNode("div", {
          class: "close-svg",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
        }, [
          _createVNode(_component_CloseSVG, {
            propId: 'print-close',
            fillColor: '#f7f9fc'
          })
        ]),
        _createElementVNode("h1", _hoisted_1, [
          _createElementVNode("div", {
            id: "return",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.returnToTroubleShooting && _ctx.returnToTroubleShooting(...args)))
          }, _hoisted_4)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _hoisted_8,
            (_ctx.clientDimensions.width <= 900)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
              : _createCommentVNode("", true),
            _hoisted_12
          ]),
          (_ctx.clientDimensions.width > 900)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
            : _createCommentVNode("", true)
        ])
      ], 2)
    ], 2)
  ]))
}